// extracted by mini-css-extract-plugin
export default {"snackbarOverlay":"styles_snackbarOverlay__zSoza","open":"styles_open__9Suut","snackbarWrp":"styles_snackbarWrp__IUDj6","snackbarText":"styles_snackbarText__cKjRp"};